import { connect } from 'react-redux';
import { ApplicationState } from '../../reducers';

export default connect(({ app: { accessToken } }: ApplicationState) => ({
  accessToken,
}));
